module.exports = __webpack_public_path__ + "img/google-play-badge-en.4b4d7be.png";